import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBRow, MDBCol,  MDBIcon, MDBCard,MDBJumbotron  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption, MDBListGroup, MDBListGroupItem,  MDBBadge, MDBTable, MDBTableBody, MDBTableHead,  MDBCardTitle,
  MDBCardText, MDBCardBody} from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Radio, Card ,Spin  } from 'antd';
import { CheckOutlined,CloseOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import Sound from 'react-sound';
import music from '../img/56.mp3'


export default class Modalteachingschedule extends Component {
    constructor(props) {
        super(props);
this.state = {
   modal: false,
   
   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   id_room:"",
   name_room:"",
   amount:"",

   SUBJCODE:"",
   SUBJNAME:"",
   CRHR:"",
   id_major:"",
   major:"",
   poname:"",
   //teacher_id:"",
   term:"",
   numregister:'',

   th:[],
   room:[],
   time:[],
   day:[],
   datacheck:[],
   datacheck2:[],
   datacheck3:[],



   roomset:'',
   timeset:'',
   timesetend:'',
   dayset:'',
   hourset:'',

   roomset2:'',
   timeset2:'',
   timesetend2:'',
   dayset2:'',
   hourset2:'',

   roomset3:'',
   timeset3:'',
   timesetend3:'',
   dayset3:'',
   hourset3:'',

   roomset4:'',
   timeset4:'',
   timesetend4:'',
   dayset4:'',
   hourset4:'',



   radio:1,
   group_id:'',
   sound:"",

   Ch_check1:'',
   Ch_check2:'',
   Ch_check3:'',

   hoursetcheckall:'',
   checktestwork:false, //เซ็คว่าเป็นฝึกงานหรือไม่
   
   //สถานะตรวจสอบซ้ำ
   ststuscheck : null,
   ststuscheck2 : null,
   ststuscheck3 : null,


   empcouncilcheck:[],
   empcouncilcheck2:[],
   empcouncilcheck3:[],
   empcouncilcheck4:[],
   day4:'', //วันสำหรับอาจารย์มีความจำเป็นที่จะไม่ว่าง
   totalchsum:'',
   stu_type:'',//ประเภทนักศึกษา

   checkroomload:false, //โหลดตรวจสอบห้องซ้ำ


   switch1: false, //ปลดล็อคเงื่อนไขทั้งหมด

   teacher_id:'', //อาจารย์ท่าน
   teacher_id2:'', //อาจารย์ท่าน2
   teacher_id3:'', //อาจารย์ท่าน3
   teacher_id4:'', //อาจารย์ท่าน4
   teacher_id5:'', //อาจารย์ท่าน5
   teacher_id6:'', //อาจารย์ท่าน6
   teacher_id7:'', //อาจารย์ท่าน7
   teacher_id8:'', //อาจารย์ท่าน8
   teacher_id9:'', //อาจารย์ท่าน9
   teacher_id10:'', //อาจารย์ท่าน10

   //ช่วงที่1
   teachercheck1:null, //สถานะตรวจสอบอาจารย์ท่านที่1
   teachercheck2:null, //สถานะตรวจสอบอาจารย์ท่านที่2
   teachercheck3:null, //สถานะตรวจสอบอาจารย์ท่านที่3
   teachercheck4:null, //สถานะตรวจสอบอาจารย์ท่านที่4
   teachercheck5:null, //สถานะตรวจสอบอาจารย์ท่านที่5
   teachercheck6:null, //สถานะตรวจสอบอาจารย์ท่านที่6
   teachercheck7:null, //สถานะตรวจสอบอาจารย์ท่านที่7
   teachercheck8:null, //สถานะตรวจสอบอาจารย์ท่านที่8
   teachercheck9:null, //สถานะตรวจสอบอาจารย์ท่านที่9
   teachercheck10:null, //สถานะตรวจสอบอาจารย์ท่านที่10



   //
   majorcheck1:null, //สถานะตรวจหมู่เรียน1

      //ช่วงที่2
      teachercheck1time2:null, //สถานะตรวจสอบอาจารย์ท่านที่1ช่วงที่2
      teachercheck2time2:null, //สถานะตรวจสอบอาจารย์ท่านที่2ช่วงที่2
      teachercheck3time2:null, //สถานะตรวจสอบอาจารย์ท่านที่3ช่วงที่2
      teachercheck4time2:null, //สถานะตรวจสอบอาจารย์ท่านที่4ช่วงที่2
      teachercheck5time2:null, //สถานะตรวจสอบอาจารย์ท่านที่5ช่วงที่2
      teachercheck6time2:null, //สถานะตรวจสอบอาจารย์ท่านที่6ช่วงที่2
      teachercheck7time2:null, //สถานะตรวจสอบอาจารย์ท่านที่7ช่วงที่2
      teachercheck8time2:null, //สถานะตรวจสอบอาจารย์ท่านที่8ช่วงที่2
      teachercheck9time2:null, //สถานะตรวจสอบอาจารย์ท่านที่9ช่วงที่2
      teachercheck10time2:null, //สถานะตรวจสอบอาจารย์ท่านที่10ช่วงที่2

  majorcheck2:null, //สถานะตรวจหมู่เรียน2
          //ช่วงที่3
          teachercheck1time3:null, //สถานะตรวจสอบอาจารย์ท่านที่1ช่วงที่3
          teachercheck2time3:null, //สถานะตรวจสอบอาจารย์ท่านที่2ช่วงที่3
          teachercheck3time3:null, //สถานะตรวจสอบอาจารย์ท่านที่3ช่วงที่3
          teachercheck4time3:null, //สถานะตรวจสอบอาจารย์ท่านที่4ช่วงที่3
          teachercheck5time3:null, //สถานะตรวจสอบอาจารย์ท่านที่5ช่วงที่3
          teachercheck6time3:null, //สถานะตรวจสอบอาจารย์ท่านที่6ช่วงที่3
          teachercheck7time3:null, //สถานะตรวจสอบอาจารย์ท่านที่7ช่วงที่3
          teachercheck8time3:null, //สถานะตรวจสอบอาจารย์ท่านที่8ช่วงที่3
          teachercheck9time3:null, //สถานะตรวจสอบอาจารย์ท่านที่9ช่วงที่3
          teachercheck10time3:null, //สถานะตรวจสอบอาจารย์ท่านที่10ช่วงที่3
     majorcheck3:null, //สถานะตรวจหมู่เรียน2

     teachercheckbutton:null, //ปุ่มส่ง
     majorcheckbutton:null, //ปุ่มส่ง
}

//this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.toggle2 = this.toggle2.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
this.getroom = this.getroom.bind(this);
this.gettime = this.gettime.bind(this);
this.getday = this.getday.bind(this);
this.check = this.check.bind(this); //เซ็คข้อมูลซ้ำช่วงที่ 1 จากฐานข้อมูล
this.checkdatabase2 = this.checkdatabase2.bind(this); //เซ็คข้อมูลซ้ำช่วงที่ 2 จากฐานข้อมูล
this.checkdatabase3 = this.checkdatabase3.bind(this); //เซ็คข้อมูลซ้ำช่วงที่ 3 จากฐานข้อมูล

this.check2 = this.check2.bind(this); //เซ็คข้อมูลซ้ำช่วงที่ 2 จาก from
this.check3 = this.check3.bind(this); //เซ็คข้อมูลซ้ำช่วงที่ 3 จาก from
this.onChangeradio = this.onChangeradio.bind(this);

this.onChangeday = this.onChangeday.bind(this);
this.onChangetime = this.onChangetime.bind(this);
this.onChangetimeend = this.onChangetimeend.bind(this);
this.onChangeroom = this.onChangeroom.bind(this);
this.onChangehour = this.onChangehour.bind(this);

this.onChangeday2 = this.onChangeday2.bind(this);
this.onChangetime2 = this.onChangetime2.bind(this);
this.onChangetimeend2 = this.onChangetimeend2.bind(this);
this.onChangeroom2 = this.onChangeroom2.bind(this);
this.onChangehour2 = this.onChangehour2.bind(this);

this.onChangeday3 = this.onChangeday3.bind(this);
this.onChangetime3 = this.onChangetime3.bind(this);
this.onChangetimeend3 = this.onChangetimeend3.bind(this);
this.onChangeroom3 = this.onChangeroom3.bind(this);
this.onChangehour3 = this.onChangehour3.bind(this);

this.onChangeday4 = this.onChangeday4.bind(this);
this.onChangetime4 = this.onChangetime4.bind(this);
this.onChangetimeend4 = this.onChangetimeend4.bind(this);
this.onChangeroom4 = this.onChangeroom4.bind(this);
this.onChangehour4 = this.onChangehour4.bind(this);
this.setdata = this.setdata.bind(this);
this.resetdataall = this.resetdataall.bind(this);
this.handleSwitchChange = this.handleSwitchChange.bind(this);
this.checksetpass1 = this.checksetpass1.bind(this); //ตั้งค่าสถานะให้อนุญาตลงตารางเรียนได้

this.sdf = this.sdf.bind(this);

this.checkteachettime1 = this.checkteachettime1.bind(this);
this.checkteachettime2 = this.checkteachettime2.bind(this);
this.checkteachettime3 = this.checkteachettime3.bind(this);

this.checkmajortime1 = this.checkmajortime1.bind(this);//ตรวจสอบหมูเรียนว่าว่างหรือไม่
this.checkmajortime2 = this.checkmajortime2.bind(this);//ตรวจสอบหมูเรียนว่าว่างหรือไม่
this.checkmajortime3 = this.checkmajortime3.bind(this);//ตรวจสอบหมูเรียนว่าว่างหรือไม่

}



toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.getroom();
  this.gettime();
  this.getday();
 
  this.setState({ sound:'' })
  this.setdata();
  this.sdf();
 // this.setState({ hourset:''})
  
 this.setState({ group_id:this.props.group_id})
 console.log(this.props.group_id);
 this.setState({ stu_type:this.props.stu_type})

}

toggle2 = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.getroom();
  this.gettime();
  this.getday();
  this.props.getteachingschedule();
  this.setState({ sound:'' })
  this.setdata();
  this.sdf();
 // this.setState({ hourset:''})
  
 this.setState({ group_id:this.props.group_id})
 console.log(this.props.group_id);
 this.setState({ stu_type:this.props.stu_type})

}

 setdata() {
    //  const { SUBJCODE } = this.props.SUBJCODE
    //  console.log(this.props.id_send);
      this.setState({ SUBJCODE:this.props.SUBJCODE})
      this.setState({ SUBJNAME:this.props.SUBJNAME})
      this.setState({ CRHR:this.props.CRHR})
      this.setState({ id_major:this.props.id_major})
      this.setState({ major:this.props.major})
      this.setState({ poname:this.props.poname})
      this.setState({ teacher_id:this.props.teacher_id})
      this.setState({ term:this.props.term})
      this.setState({ group_id:this.props.group_id})

      this.setState({ teacher_id2:this.props.teacher_id2})
      this.setState({ teacher_id3:this.props.teacher_id3})
      this.setState({ teacher_id4:this.props.teacher_id4})
      this.setState({ teacher_id5:this.props.teacher_id5})
      this.setState({ teacher_id6:this.props.teacher_id6})
      this.setState({ teacher_id7:this.props.teacher_id7})
      this.setState({ teacher_id8:this.props.teacher_id8})
      this.setState({ teacher_id9:this.props.teacher_id9})
      this.setState({ teacher_id10:this.props.teacher_id10})

    
    //  this.setState({ amount:this.props.amount})
  }


  handleSwitchChange = nr => () => {
    let switchNumber = `switch${nr}`;
    this.setState({
      [switchNumber]: !this.state[switchNumber]
    });
  }


  resetdataall() {
    //  const { SUBJCODE } = this.props.SUBJCODE
    //  console.log(this.props.id_send);
    this.setState({
      radio: 1,
      dayset2: '',
      dayset3: '',
      timeset2: '',
      timeset3: '',
      hourset2: '',
      hourset3: '',
      timesetend2: '',
      timesetend3: '',
      roomset2:'',
      roomset3:'',

      ststuscheck2:null,
      ststuscheck3:null,

    })


    
    //  this.setState({ amount:this.props.amount})
  
  }
 


 componentDidMount() {
    //  const { SUBJCODE } = this.props.SUBJCODE
   //  console.log(this.props.group_id);
     this.setState({ hourset:''})
      this.setState({ SUBJCODE:this.props.SUBJCODE})
      this.setState({ SUBJNAME:this.props.SUBJNAME})
      this.setState({ CRHR:this.props.CRHR})
      this.setState({ id_major:this.props.id_major})
      this.setState({ major:this.props.major})
      this.setState({ poname:this.props.poname})
      this.setState({ teacher_id:this.props.teacher_id})
      this.setState({ term:this.props.term})
      this.setState({ group_id:this.props.group_id})
      this.setState({ numregister:this.props.numregister})
     
    //  this.setState({ amount:this.props.amount})

      //  const  Ch_check  = Number (this.props.CRHR.substring(3, 2));
      //  const  Ch_checka  = Number (this.props.CRHR.substring(5, 4));
      const  Ch_check  = Number (this.props.Ch_check1);
      const  Ch_checka  = Number (this.props.Ch_checka1);

      //ตรวจสอบว่าเป็นวิชาเตรียมฝึกหรือไม่
      // if (this.props.SUBJNAME === 'การเตรียมฝึกประสบการณ์วิชาชีพ') {
      //   const totalch1 = 90 ;
      //   this.setState({ totalchsum:totalch1})
      // }else{
      //    const totalch2 = Ch_check + Ch_checka ;
      //    this.setState({ totalchsum:totalch2})
      // }
     const totalch = Ch_check + Ch_checka ;

   
  //  const totalch = this.state.totalchsum;

       console.log(Ch_check);
       console.log(Ch_checka);

       this.setState({ Ch_check1:this.props.CRHR.substring(4, 2)})//เซ็ควิชาฝึกงาน
       const  Ch_testwork  = Number (this.props.CRHR.substring(4, 2));

       if (Ch_testwork >= 45) {
          this.setState({ hourset:Ch_testwork}) //กำหนดค่าจำนวนชั่วโมง
          this.setState({ checktestwork:true}) //กำหนดว่าเป็นฝึกประสบการณ์
          this.setState({ hoursetcheckall:Ch_testwork}) //กำหนดค่าจำนวนชั่วโมงสำหรับเอาไว้เซ็คทั้งหมด
       }else{
          this.setState({ hourset:totalch}) //กำหนดค่าจำนวนชั่วโมง
           this.setState({ hoursetcheckall:totalch}) //กำหนดค่าจำนวนชั่วโมงสำหรับเอาไว้เซ็คทั้งหมด
       }

      
      
          this.setState({ Ch_check3:this.props.CRHR.substring(5, 4)})
          //  this.setState({ Ch_check1:Ch_check})

          //console.log(8.30 + (3*60*60*1000) )

              
          //console.log(this.props.CRHR.substring(3, 2))
          //console.log(this.props.CRHR.substring(5, 4))
          //console.log(this.props.CRHR.substring(4, 2))
          //console.log("asa")

          setTimeout(() => {
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.props.term+'/'+this.props.teacher_id)
          .then(res => {
                  this.setState({ empcouncilcheck: res.data})
          }) 
          }, 0);

          setTimeout(() => {
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.props.term+'/'+this.props.teacher_id)
          .then(res => {
                  this.setState({ empcouncilcheck2: res.data})
          }) 
          }, 0);

          setTimeout(() => {
          Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/3/'+this.props.term+'/'+this.props.teacher_id)
          .then(res => {
                  this.setState({ empcouncilcheck3: res.data})
          }) 
          }, 0);

          setTimeout(() => {
          Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/4/'+this.props.term+'/'+this.props.teacher_id)
          .then(res => {
                this.setState({ empcouncilcheck4: res.data})
                if ( res.data.length > 0) {
                    this.setState({ day4: res.data[0].day})
                }
              }) 

          }, 0);

  }





  sdf(){
    this.setState({ hourset:''})
    this.setState({ SUBJCODE:this.props.SUBJCODE})
    this.setState({ SUBJNAME:this.props.SUBJNAME})
    this.setState({ CRHR:this.props.CRHR})
    this.setState({ id_major:this.props.id_major})
    this.setState({ major:this.props.major})
    this.setState({ poname:this.props.poname})
    this.setState({ teacher_id:this.props.teacher_id})
    this.setState({ term:this.props.term})
    this.setState({ group_id:this.props.group_id})
    this.setState({ numregister:this.props.numregister})
   
  //  this.setState({ amount:this.props.amount})

    //  const  Ch_check  = Number (this.props.CRHR.substring(3, 2));
    //  const  Ch_checka  = Number (this.props.CRHR.substring(5, 4));
    const  Ch_check  = Number (this.props.Ch_check1);
    const  Ch_checka  = Number (this.props.Ch_checka1);
     const totalch = Ch_check + Ch_checka ;
     console.log(Ch_check);
     console.log(Ch_checka);

     this.setState({ Ch_check1:this.props.CRHR.substring(4, 2)})//เซ็ควิชาฝึกงาน
     const  Ch_testwork  = Number (this.props.CRHR.substring(4, 2));

     if (Ch_testwork >= 45) {
          this.setState({ hourset:Ch_testwork}) //กำหนดค่าจำนวนชั่วโมง
          this.setState({ checktestwork:true}) //กำหนดว่าเป็นฝึกประสบการณ์
          this.setState({ hoursetcheckall:Ch_testwork}) //กำหนดค่าจำนวนชั่วโมงสำหรับเอาไว้เซ็คทั้งหมด
       }else{
          this.setState({ hourset:totalch}) //กำหนดค่าจำนวนชั่วโมง
           this.setState({ hoursetcheckall:totalch}) //กำหนดค่าจำนวนชั่วโมงสำหรับเอาไว้เซ็คทั้งหมด
       }

    
    // this.setState({ hoursetcheckall:totalch}) //กำหนดค่าจำนวนชั่วโมงสำหรับเอาไว้เซ็คทั้งหมด
     this.setState({ Ch_check3:this.props.CRHR.substring(5, 4)})
   //  this.setState({ Ch_check1:Ch_check})

//console.log(8.30 + (3*60*60*1000) )

   
//console.log(this.props.CRHR.substring(3, 2))
//console.log(this.props.CRHR.substring(5, 4))
//console.log(this.props.CRHR.substring(4, 2))
//console.log("asa")

setTimeout(() => {
Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.props.term+'/'+this.props.teacher_id)
.then(res => {
       this.setState({ empcouncilcheck: res.data})
}) 
}, 0);

setTimeout(() => {
Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.props.term+'/'+this.props.teacher_id)
.then(res => {
       this.setState({ empcouncilcheck2: res.data})
}) 
}, 0);

setTimeout(() => {
Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/3/'+this.props.term+'/'+this.props.teacher_id)
.then(res => {
      this.setState({ empcouncilcheck3: res.data})
}) 
}, 0);

setTimeout(() => {
Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/4/'+this.props.term+'/'+this.props.teacher_id)
.then(res => {
    this.setState({ empcouncilcheck4: res.data})
    if ( res.data.length > 0) {
         this.setState({ day4: res.data[0].day})
    }
  }) 

}, 0);

  }


  handleChange2(event) {    this.setState({id_room: event.target.value});  }
  handleChange3(event) {    this.setState({name_room: event.target.value});  }
  handleChange4(event) {    this.setState({amount: event.target.value});  }


 
  onBlur() {
    console.log('blur');
  }
  
   onFocus() {
    console.log('focus');
   // this.setState({ sound:"" })
  }
  
   onSearch(val) {
    console.log('search:', val);
  }

//เช็คจากฐานข้อมูลช่วงที่1
  check() {
  
  this.setState({ checkroomload:true })
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("roomset", this.state.roomset);
      datafrm.append("hourset", this.state.hourset);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("SUBJCODE", this.state.SUBJCODE.substring(0, 7));
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
    
   Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheck/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
   })
   .then(res => {
    //    console.log(res);
    this.setState({ checkroomload:false })
        if (res.data.length !== 0) {
          this.setState({ datacheck: res.data, ststuscheck:false})
        //  alert("บันทึกสำเร็จ")
              if (res.data[0].group_id !== this.state.group_id) {
                  Swal.fire({
                      title: 'ช่วงเวลาที่เลือกไม่ว่าง',
                      text: 'ซ้ำกับวิชา '+res.data[0].SUBJCODE + res.data[0].SUBJNAME+' หมู่เรียน '+ res.data[0].GROUP_NO+' อาจารย์'+ res.data[0].poname ,
                      icon: 'warning',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
                    this.setState({ sound:'1' })
                    
              }else{
                if (res.data[0].group_id === this.state.group_id && res.data[0].id_course ===  this.state.SUBJCODE.substring(0, 7) ) {
                  this.setState({ ststuscheck:true })
                }else{
                    this.setState({ ststuscheck:false })

                    Swal.fire({
                      title: 'ช่วงเวลาที่เลือกไม่ว่าง',
                      text: 'ซ้ำกับวิชา '+res.data[0].SUBJCODE + res.data[0].SUBJNAME+' หมู่เรียน '+ res.data[0].GROUP_NO+' อาจารย์'+ res.data[0].poname ,
                      icon: 'warning',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })

                }

               // this.setState({ ststuscheck:true })
              }
                
          }else{
             this.setState({ ststuscheck:true })
          }

        })
       // this.toggle()
      //  this.props.getclassroom()

     
}, 600);
  }


 //อนุญาตให้ลงตารางได้ของช่วงที่ 1
 checksetpass1() {
  this.setState({ ststuscheck:true })
 }

  //เช็คจากฐานข้อมูลช่วงที่2
  checkdatabase2() {
  
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset2);
      datafrm.append("roomset", this.state.roomset2);
      datafrm.append("hourset", this.state.hourset2);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("SUBJCODE", this.state.SUBJCODE.substring(0, 7));
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
    
    Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheck/",datafrm,{
    headers: {
            'content-type': 'multipart/form-data'
           }
    })
   .then(res => {
    //    console.log(res);
        if (res.data.length !== 0) {
          this.setState({ datacheck2: res.data, ststuscheck2:false})
        //  alert("บันทึกสำเร็จ")
                 

                    if (res.data[0].group_id !== this.state.group_id) {
                
                      Swal.fire({
                        title: 'ช่วงเวลาที่เลือกถูกเลือกแล้ว',
                        icon: 'warning',
                        text: 'ซ้ำกับวิชา'+res.data[0].SUBJCODE + res.data[0].SUBJNAME+' หมู่เรียน '+ res.data[0].GROUP_NO+' อาจารย์'+ res.data[0].poname ,
                      // showCancelButton: true,
                        confirmButtonText: 'ตกลง',
                      // cancelButtonText: 'No, keep it'
                      }).then((result) => {
                      
                      })
                  }else{
                   // this.setState({ ststuscheck2:true })
                  }
          }else{
           // this.setState({ ststuscheck2:true })
          }
        })
       // this.toggle()
      //  this.props.getclassroom()
}, 600);
  }

  //เช็คจากฐานข้อมูลช่วงที่3
  checkdatabase3() {
  
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล3
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset3);
      datafrm.append("roomset", this.state.roomset3);
      datafrm.append("hourset", this.state.hourset3);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("SUBJCODE", this.state.SUBJCODE.substring(0, 7));
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
    
    Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheck/",datafrm,{
    headers: {
            'content-type': 'multipart/form-data'
           }
    })
   .then(res => {
    //    console.log(res);
        if (res.data.length !== 0) {
          this.setState({ datacheck3: res.data, ststuscheck3:false})
        //  alert("บันทึกสำเร็จ")
            
                    if (res.data[0].group_id !== this.state.group_id) {
                
                      Swal.fire({
                        title: 'ช่วงเวลาที่เลือกถูกเลือกแล้ว',
                        icon: 'warning',
                        text: 'ซ้ำกับวิชา'+res.data[0].SUBJCODE + res.data[0].SUBJNAME+' หมู่เรียน '+ res.data[0].GROUP_NO+' อาจารย์'+ res.data[0].poname ,
                      // showCancelButton: true,
                        confirmButtonText: 'ตกลง',
                      // cancelButtonText: 'No, keep it'
                      }).then((result) => {
                      })
                  }else{
                       // this.setState({ ststuscheck2:true })
                  }
          }else{
            //  this.setState({ ststuscheck3:true })
          }
        })
       // this.toggle()
      //  this.props.getclassroom()
}, 600);
  }

  
  //เซ็คซ้ำช่วงที่ 2 จากfrom
  check2() {
         if (this.state.dayset === this.state.dayset2 & this.state.timeset === this.state.timeset2 & this.state.roomset === this.state.roomset2  ) {
          Swal.fire({
                          title: 'ช่วงเวลาที่ 2 ซ้ำกับ ช่วงเวลาที่ 1 กรุณาตรวจสอบ',
                          icon: 'warning',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
           })
           this.setState({ ststuscheck2:false })
        }else{
          this.setState({ ststuscheck2:true })
         
        }
        this.checkdatabase2();
   
        
  }

  //เซ็คซ้ำช่วงที่ 3 ซ้ำกับ ช่วงที่ 1 กับ 2 หรือไม่จากfrom
  check3() {
    if (this.state.dayset === this.state.dayset3 & this.state.timeset === this.state.timeset3 & this.state.roomset === this.state.roomset3  ) {
     Swal.fire({
                     title: 'ช่วงเวลาที่ 3 ซ้ำกับ ช่วงเวลาที่ 1 กรุณาตรวจสอบ',
                     icon: 'warning',
                   // showCancelButton: true,
                     confirmButtonText: 'ตกลง',
                   // cancelButtonText: 'No, keep it'
                   }).then((result) => {
              })
              this.setState({ ststuscheck3:false })
             this.checkdatabase3()
   }else if (this.state.dayset2 === this.state.dayset3 & this.state.timeset2 === this.state.timeset3 & this.state.roomset2 === this.state.roomset3) {
    Swal.fire({
                    title: 'ช่วงเวลาที่ 3 ซ้ำกับ ช่วงเวลาที่ 2 กรุณาตรวจสอบ',
                    icon: 'warning',
                  // showCancelButton: true,
                    confirmButtonText: 'ตกลง',
                  // cancelButtonText: 'No, keep it'
                  }).then((result) => {
              })
             
        this.checkdatabase3()
         this.setState({ ststuscheck3:false })
   }else{

    this.setState({ ststuscheck3:true })
    this.checkdatabase3()
    
   }

  
 }






 //ตรวจสอบอาจารย์ว่างหรือไม่ช่วงที่1
 checkteachettime1() {

  if (this.state.teacher_id !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck1:false })  }else{ this.setState({ teachercheck1:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id2 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่2
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id2);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck2:false })  }else{ this.setState({ teachercheck2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id3 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่3
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id3);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck3:false })  }else{ this.setState({ teachercheck3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id4 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่4
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id4);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck4:false })  }else{ this.setState({ teachercheck4:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id5 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่5
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id5);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck5:false })  }else{ this.setState({ teachercheck5:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id6 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id6);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck6:false })  }else{ this.setState({ teachercheck6:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id7 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id7);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck7:false })  }else{ this.setState({ teachercheck7:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id8 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id8);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck8:false })  }else{ this.setState({ teachercheck8:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id9 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id9);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck9:false })  }else{ this.setState({ teachercheck9:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id10 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id1);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck10:false })  }else{ this.setState({ teachercheck10:true }) }
        })
     }, 600);
  }

  if (this.state.teachercheck1 === false || this.state.teachercheck2 === false || this.state.teachercheck3 === false || this.state.teachercheck4 === false || this.state.teachercheck5 === false || this.state.teachercheck6 === false || this.state.teachercheck7 === false || this.state.teachercheck8 === false || this.state.teachercheck9 === false || this.state.teachercheck10 === false) {
    this.setState({ teachercheckbutton:false})
  }else{
    this.setState({ teachercheckbutton:true})
  }


  }

  //ตรวจสอบหมู่เรียนว่างหรือไม่ช่วงที่1
 checkmajortime1() {

  if (this.state.id_major !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckmajor/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ majorcheck1:false ,majorcheckbutton:false })  }else{ this.setState({ majorcheck1:true }) }
        })
       
     }, 600);
  }

        if (this.state.majorcheck1 === false || this.state.majorcheck2 === false || this.state.majorcheck3 === false  ) {
          this.setState({ majorcheckbutton:false })
        }else{
          this.setState({ majorcheckbutton:true })
        }

  }






   //ตรวจสอบอาจารย์ว่างหรือไม่ช่วงที่2
 checkteachettime2() {

  if (this.state.teacher_id !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck1time2:false })  }else{ this.setState({ teachercheck1time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id2 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่2
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id2);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck2time2:false })  }else{ this.setState({ teachercheck2time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id3 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่3
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id3);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck3time2:false })  }else{ this.setState({ teachercheck3time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id4 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่4
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id4);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck4time2:false })  }else{ this.setState({ teachercheck4time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id5 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่5
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id5);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck5time2:false })  }else{ this.setState({ teachercheck5time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id6 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id6);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck6time2:false })  }else{ this.setState({ teachercheck6time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id7 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id7);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck7time2:false })  }else{ this.setState({ teachercheck7time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id8 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id8);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck8time2:false })  }else{ this.setState({ teachercheck8time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id9 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id9);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck9time2:false })  }else{ this.setState({ teachercheck9time2:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id10 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id10);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck10time2:false })  }else{ this.setState({ teachercheck10time2:true }) }
        })
     }, 600);
  }

  if (this.state.teachercheck1time2 === false || this.state.teachercheck2time2 === false || this.state.teachercheck3time2 === false || this.state.teachercheck4time2 === false || this.state.teachercheck5time2 === false || this.state.teachercheck6time2 === false || this.state.teachercheck7time2 === false || this.state.teachercheck8time2 === false || this.state.teachercheck9time2 === false || this.state.teachercheck10time2 === false) {
    this.setState({ teachercheckbutton:false})
  }else{
    this.setState({ teachercheckbutton:true})
  }


  }

   //ตรวจสอบหมู่เรียนว่างหรือไม่ช่วงที่2
 checkmajortime2() {

  if (this.state.id_major !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset2);
      datafrm.append("timesetend", this.state.timesetend2);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckmajor/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ majorcheck2:false })  }else{ this.setState({ majorcheck2:true }) }
        })
       
     }, 600);
  }

  if (this.state.majorcheck1 === false || this.state.majorcheck2 === false || this.state.majorcheck3 === false  ) {
    this.setState({ majorcheckbutton:false })
  }else{
    this.setState({ majorcheckbutton:true })
  }

  }


//ตรวจสอบอาจารย์ว่างหรือไม่ช่วงที่3
checkteachettime3() {

  if (this.state.teacher_id !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck1time3:false })  }else{ this.setState({ teachercheck1time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id2 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่2
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id2);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck2time3:false })  }else{ this.setState({ teachercheck2time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id3 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่3
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id3);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck3time3:false })  }else{ this.setState({ teachercheck3time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id4 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่4
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id4);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck4time3:false })  }else{ this.setState({ teachercheck4time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id5 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่5
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id5);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck5time3:false })  }else{ this.setState({ teachercheck5time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id6 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id6);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck6time3:false })  }else{ this.setState({ teachercheck6time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id7 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id7);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck7time3:false })  }else{ this.setState({ teachercheck7time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id8 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id8);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck8time3:false })  }else{ this.setState({ teachercheck8time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id9 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id9);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck9time3:false })  }else{ this.setState({ teachercheck9time3:true }) }
        })
     }, 600);
  }

  if (this.state.teacher_id10 !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่6
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("teacher_id", this.state.teacher_id10);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckteacher/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ teachercheck10time3:false })  }else{ this.setState({ teachercheck10time3:true }) }
        })
     }, 600);
  }


  if (this.state.teachercheck1time3 === false || this.state.teachercheck2time3 === false || this.state.teachercheck3time3 === false || this.state.teachercheck4time3 === false || this.state.teachercheck5time3 === false || this.state.teachercheck6time3 === false || this.state.teachercheck7time3 === false || this.state.teachercheck8time3 === false || this.state.teachercheck9time3 === false || this.state.teachercheck10time3 === false) {
    this.setState({ teachercheckbutton:false})
  }else{
    this.setState({ teachercheckbutton:true})
  }


  }

     //ตรวจสอบหมู่เรียนว่างหรือไม่ช่วงที่3
 checkmajortime3() {

  if (this.state.id_major !== null) {
    setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูลคนที่1
      datafrm.append("timeset", this.state.timeset3);
      datafrm.append("timesetend", this.state.timesetend3);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("term", this.state.term);
      Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/getcheckmajor/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
     })
    .then(res => {
        if (res.data.length !== 0) { this.setState({ majorcheck3:false ,majorcheckbutton:false})  }else{ this.setState({ majorcheck3:true }) }
        })
       
     }, 600);
  }

        if (this.state.majorcheck1 === false || this.state.majorcheck2 === false || this.state.majorcheck3 === false  ) {
          this.setState({ majorcheckbutton:false })
        }else{
          this.setState({ majorcheckbutton:true })
        }


  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("timeset", this.state.timeset);
      datafrm.append("timesetend", this.state.timesetend);
      datafrm.append("dayset", this.state.dayset);
      datafrm.append("roomset", this.state.roomset);
      datafrm.append("hourset", this.state.hourset);
      datafrm.append("timeset2", this.state.timeset2);
      datafrm.append("timesetend2", this.state.timesetend2);
      datafrm.append("dayset2", this.state.dayset2);
      datafrm.append("roomset2", this.state.roomset2);
      datafrm.append("hourset2", this.state.hourset2);
      datafrm.append("timeset3", this.state.timeset3);
      datafrm.append("timesetend3", this.state.timesetend3);
      datafrm.append("dayset3", this.state.dayset3);
      datafrm.append("roomset3", this.state.roomset3);
      datafrm.append("hourset3", this.state.hourset3);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("SUBJCODE", this.state.SUBJCODE.substring(0, 7));
      datafrm.append("teacher_id", this.state.teacher_id);
      datafrm.append("term", this.state.term);
      datafrm.append("group_id", this.state.group_id);
      datafrm.append("stu_type", this.state.stu_type);

      
    
      
   Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/updategroupid/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
           }
   })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'บันทึกข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
                 }
        })
        this.setState({ hourset:''})
        this.toggle2()
      //  this.props.getclassroom()

}, 2000);


//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 
  }


  getroom() {
    //  console.log(`selected ${value}`);
    Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroom')
    .then(res => {
      this.setState({ room: res.data})
    })
     //  const idemp = value;
     //  this.setState({ idemp });
    }


  gettime() {
      //  console.log(`selected ${value}`);
      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/gettime')
      .then(res => {
        this.setState({ time: res.data})
      })
       //  const idemp = value;
       //  this.setState({ idemp });
   }


  getday() {
        //  console.log(`selected ${value}`);
        Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getdate')
        .then(res => {
          this.setState({ day: res.data})
        })
         //  const idemp = value;
         //  this.setState({ idemp });
   }


//ช่วงที่1
  onChangeday(value) {
     this.setState({ dayset:value})
  }
  onChangetime(value) {
    this.setState({ timeset:value})

    const settime = this.state.hourset+":00" ;
 //   console.log(settime)

//เวลาที่เลือกมา
    const [hoursPart, minutesPart] = value.split(":");
    const sdt = Number(hoursPart) + Number(minutesPart) / 60 ;
 //   console.log(sdt)

//จำนวนเวลาจากวิชาที่จะบวก
    const [hoursPart2, minutesPart2] = settime.split(":");
    const sdt2 = Number(hoursPart2) + Number(minutesPart2) / 60 ;
  //  console.log(sdt2)


   // teachingschedule.id_major.substring(2, 3) === '1'


//รวมเวลาที่เลือกกับเวลาจากรายวิชา
    const sdsum = sdt+sdt2;

    const numHours = Math.floor(sdsum);
    const numMinutes = Math.round((sdsum - numHours) * 60);
    const sdss = `${numHours < 10 ? "0" : ""}${numHours}:${numMinutes < 10 ? "0" : ""}${numMinutes}`;
  //  console.log(sdss)
   // this.setState({ timesetend:sdss})

   
   // console.log(this.state.id_major.substring(2, 3))
     //เซ็คประเภทนักศึกษา ปกติกำแพง - ปกติแม่สอดหรอไม่
    if (this.state.id_major.substring(2, 3) == 1 || this.state.id_major.substring(2, 3) == 5 || this.state.id_major.substring(2, 3) == 2 || this.state.id_major.substring(2, 3) == 3)  {
      
      this.setState({ timesetend:sdss})

    } else {

      const  time2 = Number (this.state.hourset*55)
      const  ddf = time2-5
      const  now = new Date("December 25, 1995 "+value+" ");
      const totalsss = now.setMinutes(now.getMinutes()+ddf);
      const wanwela = new Date(totalsss)
     // const hourssa = ((wanwela + 11) % 12 + 1) 
      var options = { hour12: false };
      const wanwela1 =  wanwela.toLocaleTimeString('en-US', options)

      this.setState({ timesetend:wanwela1.substring(0, 5)})
    }



  }


  onChangetimeend(value) {
    this.setState({ timesetend:value})
  }
  onChangeroom(value) {
    this.setState({ sound:"" })
    this.setState({ roomset:value})
    setTimeout(() => {
       this.check();
       this.checkteachettime1();
        this.checkmajortime1();
    }, 300);
  }
  onChangehour =  event => {
    this.setState({
      hourset: event.target.value
    })
  }

  //ช่วงที่2
  onChangeday2(value) {
    this.setState({ dayset2:value})
 }
 onChangetime2(value) {
   this.setState({ timeset2:value})

   const settime2 = this.state.hourset2+":00" ;
   console.log(settime2)

//เวลาที่เลือกมา
   const [hoursPart, minutesPart] = value.split(":");
   const sdt = Number(hoursPart) + Number(minutesPart) / 60 ;
   console.log(sdt)

//จำนวนเวลาจากวิชาที่จะบวก
   const [hoursPart2, minutesPart2] = settime2.split(":");
   const sdt2 = Number(hoursPart2) + Number(minutesPart2) / 60 ;
   console.log(sdt2)


//รวมเวลาที่เลือกกับเวลาจากรายวิชา
   const sdsum = sdt+sdt2;

   const numHours = Math.floor(sdsum);
   const numMinutes = Math.round((sdsum - numHours) * 60);
   const sdss = `${numHours < 10 ? "0" : ""}${numHours}:${numMinutes < 10 ? "0" : ""}${numMinutes}`;
   console.log(sdss)
  // this.setState({ timesetend2:sdss}) //อันเดิม



  if (this.state.id_major.substring(2, 3) == 1 || this.state.id_major.substring(2, 3) == 5 || this.state.id_major.substring(2, 3) == 2 || this.state.id_major.substring(2, 3) == 3) {
      
    this.setState({ timesetend2:sdss})

  } else {

    const  time2 = Number (this.state.hourset2*55)
    const  ddf = time2-5
    const  now = new Date("December 25, 1995 "+value+" ");
    const totalsss = now.setMinutes(now.getMinutes()+ddf);
    const wanwela = new Date(totalsss)
   // const hourssa = ((wanwela + 11) % 12 + 1) 
    var options = { hour12: false };
    const wanwela1 =  wanwela.toLocaleTimeString('en-US', options)

    this.setState({ timesetend2:wanwela1.substring(0, 5)})
  }




 }
 onChangetimeend2(value) {
   this.setState({ timesetend2:value}) 
 }
 onChangeroom2(value) {
   this.setState({ roomset2:value})
   setTimeout(() => {
      this.check2();
      this.checkteachettime2();
       this.checkmajortime2();
   }, 500);
 }
 onChangehour2 =  event => {
   this.setState({
     hourset2: event.target.value
   })
 }

  //ช่วงที่3
 onChangeday3(value) {
    this.setState({ dayset3:value})
 }
 onChangetime3(value) {
   this.setState({ timeset3:value})
   const settime2 = this.state.hourset3+":00" ;
  // console.log(settime2)

//เวลาที่เลือกมา
   const [hoursPart, minutesPart] = value.split(":");
   const sdt = Number(hoursPart) + Number(minutesPart) / 60 ;
  // console.log(sdt)

//จำนวนเวลาจากวิชาที่จะบวก
   const [hoursPart2, minutesPart2] = settime2.split(":");
   const sdt2 = Number(hoursPart2) + Number(minutesPart2) / 60 ;
  // console.log(sdt2)


//รวมเวลาที่เลือกกับเวลาจากรายวิชา
   const sdsum = sdt+sdt2;

   const numHours = Math.floor(sdsum);
   const numMinutes = Math.round((sdsum - numHours) * 60);
   const sdss = `${numHours < 10 ? "0" : ""}${numHours}:${numMinutes < 10 ? "0" : ""}${numMinutes}`;
  // console.log(sdss)
  // this.setState({ timesetend3:sdss})


   if (this.state.id_major.substring(2, 3) == 1 || this.state.id_major.substring(2, 3) == 5 || this.state.id_major.substring(2, 3) == 2 || this.state.id_major.substring(2, 3) == 3) {
      
    this.setState({ timesetend3:sdss})

  } else {

    const  time2 = Number (this.state.hourset3*55)
    const  ddf = time2-5
    const  now = new Date("December 25, 1995 "+value+" ");
    const totalsss = now.setMinutes(now.getMinutes()+ddf);
    const wanwela = new Date(totalsss)
   // const hourssa = ((wanwela + 11) % 12 + 1) 
    var options = { hour12: false };
    const wanwela1 =  wanwela.toLocaleTimeString('en-US', options)

    this.setState({ timesetend3:wanwela1.substring(0, 5)})
  }

 }
 onChangetimeend3(value) {
   this.setState({ timesetend3:value})
  
  
 }
 onChangeroom3(value) {
   this.setState({ roomset3:value})
   setTimeout(() => {
      this.check3();
      this.checkteachettime3();
      this.checkmajortime3();
   }, 500);
 }
 onChangehour3 =  event => {
   this.setState({
     hourset3: event.target.value
   })
 }

 //ช่วงที่4
 onChangeday4(value) {
  this.setState({ dayset4:value})
}
onChangetime4(value) {
 this.setState({ timeset4:value})
}
onChangetimeend4(value) {
 this.setState({ timesetend4:value})
}
onChangeroom4(value) {
 this.setState({ roomset4:value})
 setTimeout(() => {
    this.check()
 }, 500);
}
onChangehour4 =  event => {
 this.setState({
   hourset4: event.target.value
 })
}




 onChangeradio = e => {
  //  console.log('radio checked', e.target.value);
   // setValue(e.target.value);
    this.setState({
      radio: e.target.value
    })

    if (e.target.value === 1) {
      this.setState({

        dayset2: '',
        dayset3: '',
        timeset2: '',
        timeset3: '',
        hourset2: '',
        hourset3: '',
        timesetend2: '',
        timesetend3: '',
        roomset2:'',
        roomset3:'',

        ststuscheck2:null,
        ststuscheck3:null,

      })
    }

    if (e.target.value === 2) {
      this.setState({
        dayset3: '',
        timeset3: '',
        hourset3: '',
        timesetend3: '',
        roomset3:'',

        ststuscheck3:null,
      })
    }

  };

  


    render() {
      //    console.log(this.state.group_id)
        //  console.log(this.state.Ch_check2)
        //  console.log(this.state.Ch_check1)
        //  console.log("jkkk")
       //   console.log(this.state.datacheck)
         // const [value] = React.useState(1);

         console.log(this.state.majorcheck1);
         console.log(this.state.majorcheck2);
          console.log(this.state.switch1);


             console.log(this.state.teachercheckbutton);
             console.log(this.state.majorcheckbutton);
            

         const sumch = Number(this.state.hourset) + Number(this.state.hourset2) + Number(this.state.hourset3) ;



        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle} color="deep-purple" size="sm"><MDBIcon icon="plus" /></MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" fullHeight position="left">

              <MDBModalHeader toggle={this.toggle}><MDBIcon icon="plus-circle" /> เพิ่ม วัน เวลา ห้องเรียน</MDBModalHeader>
              {/* <MDBContainer> */}
              <MDBModalBody>
              <div>
             {/* {console.log(this.state.th)}  */}

             {/* <Alert
              message={<><p>วิชา : {this.state.SUBJCODE} {this.state.SUBJNAME} {this.state.CRHR}</p>  
              <p>หมู่เรียน : {this.state.id_major} {this.state.major}</p> 
              <p>อาจารย์ : {this.state.poname}</p>
              <p>จำนวน : {this.state.numregister} คน</p>
              <p>ประเภทนักศึกษา : {this.state.stu_type} </p>
               </>}
              description=""
              type="success"
             /> */}

      <MDBCard >
        <MDBCardBody>
          <MDBCardTitle>วิชา : {this.state.SUBJCODE} {this.state.SUBJNAME} {this.state.CRHR}</MDBCardTitle>
          <MDBCardText>
              <p>หมู่เรียน : {this.state.id_major} {this.state.major}</p> 
              <p>อาจารย์ : {this.state.poname}</p>
              <p>จำนวน : {this.state.numregister} คน</p>
              <p>ประเภทนักศึกษา : {this.state.stu_type} </p>
          </MDBCardText>
        </MDBCardBody>
      </MDBCard>
            <br/>
       

                {/* { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมสภามหาวิทยาลัย</a> ทุกวันพฤหัสบดี 
                </MDBAlert>
                </MDBCard>
                </>}


                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร 
                </MDBAlert>
                </MDBCard>
                </>}

                { this.state.empcouncilcheck3.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการสภาวิชาการ</a> ทุกวันพฤหัสบดี 
                </MDBAlert>
                </MDBCard>
                </>}


                { this.state.empcouncilcheck4.length === 0 ? <> </> : 
                <>
                <br/>
                <MDBCard>
                <MDBAlert color="danger ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการแจ้งติดภารกิจ</a> ทุกวัน {this.state.day4} 
                </MDBAlert>
                </MDBCard>
                </>} */}
  <MDBJumbotron> 


 



 <h4 className="text-center">เลือกช่วงเวลา</h4>
  <MDBRow className="text-center d-flex justify-content-center">
   <br/>
  <div className="d-flex justify-content-center">
    <Radio.Group onChange={this.onChangeradio} >
      <Radio value={1}>1 ช่วงเวลา</Radio>
      <Radio value={2}>2 ช่วงเวลา</Radio>
      <Radio value={3}>3 ช่วงเวลา</Radio>
      {/* <Radio value={4}>4 ช่วงเวลา</Radio> */}
    </Radio.Group>
  </div>
  </MDBRow>
  <br/>

  
<p>ตรวจสอบช่วงเวลาของอาจารย์ และหมู่เรียน</p>



<MDBTable small>
      <MDBTableHead color="primary-color" textWhite>
        <tr>
          <th>อาจารย์ / หมู่เรียน</th>
          <th>ช่วงที่1</th>
          { this.state.radio === 2 || this.state.radio === 3 ?<>
          <th>ช่วงที่2</th>
          </>:<></>} 
          { this.state.radio === 3 ?<>
          <th>ช่วงที่3</th>
          </>:<></>} 
        </tr>
      </MDBTableHead>

      <MDBTableBody>
        {this.state.teacher_id !== null ?<>
          <tr>
          <td>อาจารย์ {this.state.poname}</td>
          <td>{this.state.teachercheck1 === false ?<>
                {this.state.teachercheck1 === null ?<>
                  <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                </>:<>
                   <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                </>}
             </>:<>
             {this.state.teachercheck1 === null ?<>
              <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
             </>:<>
              <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
             </>}
            
             </>}
          </td>
                 { this.state.radio === 2 || this.state.radio === 3 ?<>
                      <td>
                        {this.state.teachercheck1time2 === false ?<>
                              {this.state.teachercheck1time2 === null ?<>
                                <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                              </>:<>
                                <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                              </>}
                          </>:<>
                          {this.state.teachercheck1time2 === null ?<>
                            <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
                          </>:<>
                            <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
                          </>}
                          
                          </>}
                      </td>
                </>:<></>}
                { this.state.radio === 3 ?<>
                      <td>
                        {this.state.teachercheck1time3 === false ?<>
                              {this.state.teachercheck1time3 === null ?<>
                                <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                              </>:<>
                                <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                              </>}
                          </>:<>
                          {this.state.teachercheck1time3 === null ?<>
                            <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
                          </>:<>
                            <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
                          </>}
                          
                          </>}
                      </td>
                </>:<></>}
        </tr>
{/* เซ็คหมู่เรียน */}
        <tr>
          <td>หมู่เรียน {this.state.id_major}</td>
          <td>{this.state.majorcheck1 === false ?<>
                {this.state.majorcheck1 === null ?<>
                  <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                </>:<>
                   <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                </>}
             </>:<>
             {this.state.majorcheck1 === null ?<>
              <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
             </>:<>
              <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
             </>}
            
             </>}
          </td>
                 { this.state.radio === 2 || this.state.radio === 3 ?<>
                      <td>
                        {this.state.majorcheck2 === false ?<>
                              {this.state.majorcheck2 === null ?<>
                                <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                              </>:<>
                                <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                              </>}
                          </>:<>
                          {this.state.majorcheck2 === null ?<>
                            <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
                          </>:<>
                            <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
                          </>}
                          
                          </>}
                      </td>
                </>:<></>}
                { this.state.radio === 3 ?<>
                      <td>
                        {this.state.majorcheck3 === false ?<>
                              {this.state.majorcheck3 === null ?<>
                                <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                              </>:<>
                                <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                              </>}
                          </>:<>
                          {this.state.majorcheck3 === null ?<>
                            <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
                          </>:<>
                            <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
                          </>}
                          
                          </>}
                      </td>
                </>:<></>}
        </tr>
        </>:<></>}

        {this.state.teacher_id2 !== null ?<>
          <tr>
          <td>{this.state.teacher_id2}</td>
          <td>{this.state.teachercheck2 === false ?<>
                {this.state.teachercheck2 === null ?<>
                   <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                </>:<>
                   <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                </>}
             </>:<>
             {this.state.teachercheck2 === null ?<>
              <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
             </>:<>
              <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
             </>}
            
             </>}
          </td>
          { this.state.radio === 2 || this.state.radio === 3 ?<>
            <td>{this.state.teachercheck2time2 === false ?<>
                {this.state.teachercheck2time2 === null ?<>
                   <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                </>:<>
                   <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                </>}
             </>:<>
             {this.state.teachercheck2time2 === null ?<>
              <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
             </>:<>
              <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
             </>}
            
             </>}
          </td>
          </>:<></>}
          { this.state.radio === 3 ?<>
            <td>{this.state.teachercheck2time3 === false ?<>
                {this.state.teachercheck2time3 === null ?<>
                   <p><MDBIcon far icon="hourglass" />รอตรวจสอบ</p>
                </>:<>
                   <p><MDBIcon icon="times" className="red-text pr-3" /> ไม่ว่าง</p>
                </>}
             </>:<>
             {this.state.teachercheck2time3 === null ?<>
              <p><MDBIcon far icon="hourglass" /> รอตรวจสอบ</p>
             </>:<>
              <p><MDBIcon icon="check" className="green-text pr-3" /> ว่าง</p>
             </>}
            
             </>}
          </td>
          </>:<></>}
        </tr>
        </>:<></>}
       


       
      </MDBTableBody>
    </MDBTable>


      <div className='custom-control custom-switch'>
        <input
          type='checkbox'
          className='custom-control-input'
          id='customSwitches'
          checked={this.state.switch1}
          onChange={this.handleSwitchChange(1)}
          readOnly
        />
        <label className='custom-control-label' htmlFor='customSwitches'>
         ปลดล็อกเงื่อนไขทั้งหมด
        </label>
      </div>

  <br/>

       
    <p><Badge status="success" /> ช่วงที่ 1 </p>
    <MDBRow>


      
    <MDBCol sm="2" md="2"> <p>วัน </p>   
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกวัน"
                    optionFilterProp="children"
                    onChange={this.onChangeday}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.day.map((day,index )  => 
                   <option value={day.id_day}>{day.name_day}</option>
                   )}
            </Select>
    </MDBCol>

    <MDBCol sm="2"> <p>จำนวนชั่วโมง </p>
        <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangehour} 
         value={this.state.hourset}
         style={{ width: 120 }}
         />
    </MDBCol>

    <MDBCol sm="2" md="2"> <p>เวลาเริ่ม </p>
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetime}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                  //  <option value={time.name_time}>{time.name_time}</option>
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select>
    </MDBCol>

    <MDBCol sm="2"> <p>เวลาสิ้นสุด </p>
        {/* <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetimeend}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select> */}
        <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangetimeend} 
         value={this.state.timesetend}
         style={{ width: 120 }}
         disabled 
         />
    </MDBCol>

    

    <MDBCol sm="2">  <p>ห้องเรียน</p>
              <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกห้องเรียน"
                    optionFilterProp="children"
                    onChange={this.onChangeroom}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.room.map((room,index )  => 
                   <option value={room.id_room}>{room.id_room +" ("+ room.amount+" คน)"}</option>
                   )}
            </Select>
      </MDBCol>
 

      <MDBCol sm="2"> <p>t/f </p>
      {this.state.checkroomload === true ?<> <Spin /></> :<>
       { this.state.ststuscheck === true ?<> <CheckOutlined style={{ fontSize: '16px', color: '#007E33' }} /> ผ่าน  </> :<></> }
      { this.state.ststuscheck === false ?<> <CloseOutlined style={{ fontSize: '16px', color: '#CC0000' }} />ไม่ผ่าน </> :<></> }
      </>}
     
      </MDBCol>


     </MDBRow>
     <br/>
     { this.state.ststuscheck === false ?<> <MDBBtn color="warning" onClick={this.checksetpass1}>อนุญาติให้ลงตารางเรียนได้</MDBBtn> </> :<></> }


     { this.state.radio >= 2 ? <>
      
      {/* ช่วงที่ 2 */}
    <p><Badge status="red" /> ช่วงที่ 2 </p>
    <MDBRow>
    <MDBCol sm="2" md="2"> <p>วัน </p>   
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกวัน"
                    optionFilterProp="children"
                    onChange={this.onChangeday2}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.day.map((day,index )  => 
                   <option value={day.id_day}>{day.name_day}</option>
                   )}
        </Select>
    </MDBCol>

     <MDBCol sm="2"> <p>จำนวนชั่วโมง </p>
      
        <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangehour2} 
         style={{ width: 120 }}
         />
    </MDBCol>

    <MDBCol sm="2" md="2"> <p>เวลาเริ่ม </p>
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetime2}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select>
    </MDBCol>
    <MDBCol sm="2"> <p>เวลาสิ้นสุด </p>
        {/* <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetimeend2}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select> */}
            <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangetimeend2} 
         value={this.state.timesetend2}
         style={{ width: 120 }}
         disabled 
         />
    </MDBCol>
   
    <MDBCol sm="2">  <p>ห้องเรียน </p>
              <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกสถานที่"
                    optionFilterProp="children"
                    onChange={this.onChangeroom2}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   {this.state.room.map((room,index )  => 
                   <option value={room.id_room}>{room.id_room+" ("+ room.amount+" คน)"}</option>
                   )}
            </Select>
      </MDBCol>
      <MDBCol sm="2">  <p>t/f </p>
      { this.state.ststuscheck2 === true ?<><CheckOutlined style={{ fontSize: '16px', color: '#007E33' }} /> ผ่าน </> :<></> }
      { this.state.ststuscheck2 === false ?<> <CloseOutlined style={{ fontSize: '16px', color: '#CC0000' }} /> ไม่ผ่าน </> :<></> }
      </MDBCol>
     </MDBRow>

      </> :<></>}
      <br/>


      { this.state.radio >= 3 ? <>
      {/* ช่วงที่ 3 */}
    <p><Badge status="cyan" /> ช่วงที่ 3 </p>
    <MDBRow>
    <MDBCol sm="2" md="2"> <p>วัน </p>   
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกวัน"
                    optionFilterProp="children"
                    onChange={this.onChangeday3}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.day.map((day,index )  => 
                   <option value={day.id_day}>{day.name_day}</option>
                   )}
            </Select>
    </MDBCol>

     <MDBCol sm="2"> <p>จำนวนชั่วโมง </p>
      
        <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangehour3} 
         style={{ width: 120 }}
         />
    </MDBCol>

    <MDBCol sm="2" md="2"> <p>เวลาเริ่ม </p>
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetime3}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select>
    </MDBCol>

    <MDBCol sm="2"> <p>เวลาสิ้นสุด </p>
        {/* <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetimeend3}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select> */}
            <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangetimeend3} 
         value={this.state.timesetend3}
         style={{ width: 120 }}
         disabled 
         />
    </MDBCol>

    
 
    <MDBCol sm="2">  <p>ห้องเรียน </p>
              <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกห้องเรียน"
                    optionFilterProp="children"
                    onChange={this.onChangeroom3}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   {this.state.room.map((room,index )  => 
                   <option value={room.id_room}>{room.id_room+" ("+ room.amount+" คน)"}</option> 
                   )}
            </Select>
      </MDBCol>
      <MDBCol sm="2">  <p>t/f </p>
      { this.state.ststuscheck3 === true ?<><CheckOutlined style={{ fontSize: '16px', color: '#007E33' }} /> ผ่าน </> :<></> }
      { this.state.ststuscheck3 === false ?<> <CloseOutlined style={{ fontSize: '16px', color: '#CC0000' }} /> ไม่ผ่าน</> :<></> }
      </MDBCol>
     </MDBRow>
      </> :<></>}
              <br/>
      { this.state.radio >= 4 ? <>
      {/* ช่วงที่ 3 */}
    <p><Badge status="purple" /> ช่วงที่ 4 </p>
    <MDBRow>
    <MDBCol sm="2" md="2"> <p>วัน </p>   
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกวัน"
                    optionFilterProp="children"
                    onChange={this.onChangeday4}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.day.map((day,index )  => 
                   <option value={day.id_day}>{day.name_day}</option>
                   )}
            </Select>
    </MDBCol>
    <MDBCol sm="2" md="2"> <p>เวลาเริ่ม </p>
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetime4}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select>
    </MDBCol>

    <MDBCol sm="2"> <p>เวลาสิ้นสุด </p>
        <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกเวลา"
                    optionFilterProp="children"
                    onChange={this.onChangetimeend4}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   
                   {this.state.time.map((time,index )  => 
                   <option value={time.name_time}>{time.name_time}</option>
                   )}
            </Select>
    </MDBCol>

    <MDBCol sm="2"> <p>จำนวนชั่วโมง </p>
      
        <Input placeholder="จำนวนชั่วโมง" 
         onChange={this.onChangehour4} 
         style={{ width: 120 }}
         />
    </MDBCol>

    <MDBCol sm="2">  <p>ห้องเรียน </p>
              <Select
                    showSearch
                    style={{ width: 120 }}
                    placeholder="เลือกห้องเรียน"
                    optionFilterProp="children"
                    onChange={this.onChangeroom4}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                   {this.state.room.map((room,index )  => 
                   <option value={room.id_room}>{room.id_room+" ("+ room.amount+" คน)"}</option>
                   )}
            </Select>
      </MDBCol>
     </MDBRow>
      </> :<></>}


     <p>จำนวนจากรายวิชา {this.state.hoursetcheckall} ชั่วโมง : จำนวนที่เพิ่ม {sumch} </p> 
     {/* <br/>
    <div className="text-center">
      <MDBBtn color="warning" onClick={this.resetdataall} >ยกเลิก</MDBBtn> 
    </div> */}
     <br/>





    
                    <br/>
      {sumch >= this.state.hoursetcheckall ? <></> :<> 

      {this.state.checktestwork === true ?<></> :<><MDBAlert color="danger" >
      <CloseOutlined />  ไม่สามารถบันทึกได้ เนื่องจากจำนวนชั่วโมงน้อยกว่าที่กำหนดในรายวิชา
      </MDBAlert></>}
        
      </>}

      </MDBJumbotron>
               {/* <p>รหัสห้อง </p>   
               <MDBInput type="text" label="รหัสห้อง" value={this.state.id_room} onChange={this.handleChange2} outline />

               <p>ชื่อห้อง </p>
               <MDBInput type="text" label="ชื่อห้อง" value={this.state.name_room} onChange={this.handleChange3} outline />

               <p>จำนวนที่นั่ง </p>   
               <MDBInput type="text" label="จำนวนที่นั่ง" value={this.state.amount} onChange={this.handleChange4} outline />
               */}
             
               
              </div>
              </MDBModalBody>
              {/* </MDBContainer> */}
              { this.state.sound  === '1' ?<>
               <Sound
                    url={music}
                    playStatus={Sound.status.PLAYING}
                    playFromPosition={300 /* in milliseconds */}
                    onLoading={this.handleSongLoading}
                    onPlaying={this.handleSongPlaying}
                    onFinishedPlaying={this.handleSongFinishedPlaying}
                  />
              </>:<></>}
             
               
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle2}>ปิด</MDBBtn>



                
              {this.state.switch1 === false ?<>

                  {this.state.radio === 1?<>
                                      { this.state.ststuscheck  === true && this.state.teachercheckbutton === true && this.state.majorcheckbutton === true  ? <>
                                      {sumch >= this.state.hoursetcheckall ? <> <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> :<> 

                                        {/* เซ็คว่าเป็นฝึกงานหรือไม่ ถ้าใช่จะสามารถบันทึกข้อมูลได้ ถ้าไม่ใช่จะไม่สามารถบันทึกข้อมูลได้ */}
                                        {this.state.checktestwork === true && this.state.teachercheckbutton === true && this.state.majorcheckbutton === true  ?<><MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></>:<> <MDBBtn color="primary" disabled  >บันทึก</MDBBtn></>}
                                      

                                        </>}
                                        </>:<>
                                        {this.state.checktestwork === true && this.state.teachercheckbutton === true && this.state.majorcheckbutton === true ?<><MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></>:<> <MDBBtn color="primary" disabled  >บันทึก</MDBBtn></>}
                                    
                                      </>}
                   </>:<></>}

                  {this.state.radio === 2 ?<>
                          { this.state.ststuscheck  === true && this.state.ststuscheck2  === true && this.state.teachercheckbutton === true && this.state.majorcheckbutton === true  ? <>
                          {sumch >= this.state.hoursetcheckall ? <> <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> :<> 
                          <MDBBtn color="primary" disabled  >บันทึก</MDBBtn>
                        </>}

                        </>:<>
                        <MDBBtn color="primary" disabled  >บันทึก</MDBBtn>
                        </>}
                    </>:<></>}

                    {this.state.radio === 3 ?<>
                          { this.state.ststuscheck  === true && this.state.ststuscheck2  === true && this.state.ststuscheck3  === true && this.state.teachercheckbutton === true && this.state.majorcheckbutton === true  ? <>
                          {sumch >= this.state.hoursetcheckall ? <> <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> :<> 
                          <MDBBtn color="primary" disabled  >บันทึก</MDBBtn>
                        </>}

                        </>:<>
                        <MDBBtn color="primary" disabled  >บันทึก</MDBBtn>
                        </>}
                    </>:<></>}

              </>:<>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </>}


               
               
                
              </MDBModalFooter>

{/* {this.state.sou  === true} */}
             
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
